/**
 * 需要隐藏左侧菜单的路径列表
 * 支持精确匹配和路径前缀匹配
 */
const HIDE_MENU_PATHS: string[] = [
  '/login',
  // '/firewall/api-key', // API-Key详情页
  // 可以在这里添加更多需要隐藏菜单的路径
];

/**
 * 判断指定路径是否需要隐藏左侧菜单
 * @param pathname 当前路径
 * @returns 如果需要隐藏菜单返回 true，否则返回 false
 */
export function shouldHideMenu(pathname: string): boolean {
  return HIDE_MENU_PATHS.some((hidePath) => {
    // 精确匹配
    if (pathname === hidePath) {
      return true;
    }
    // 路径前缀匹配（支持动态路由）
    if (pathname.startsWith(hidePath + '/')) {
      return true;
    }
    return false;
  });
}

/**
 * 添加需要隐藏菜单的路径
 * @param path 路径字符串或路径数组
 */
export function addHideMenuPath(path: string | string[]): void {
  const paths = Array.isArray(path) ? path : [path];
  paths.forEach((p) => {
    if (!HIDE_MENU_PATHS.includes(p)) {
      HIDE_MENU_PATHS.push(p);
    }
  });
}

/**
 * 移除隐藏菜单的路径
 * @param path 路径字符串
 */
export function removeHideMenuPath(path: string): void {
  const index = HIDE_MENU_PATHS.indexOf(path);
  if (index > -1) {
    HIDE_MENU_PATHS.splice(index, 1);
  }
}

import type { MenuNode } from './menu';

/**
 * 过滤菜单数据，移除需要隐藏菜单的路径
 * @param menuData 菜单数据数组
 * @returns 过滤后的菜单数据
 */
export function filterMenuData(menuData: MenuNode[]): MenuNode[] {
  if (!Array.isArray(menuData)) {
    return [];
  }

  return menuData
    .map((item) => {
      // 检查当前菜单项的路径是否需要隐藏
      if (item.path && shouldHideMenu(item.path)) {
        return null; // 标记为需要移除
      }

      // 如果有子菜单，递归过滤
      if (item.routes && Array.isArray(item.routes)) {
        const filteredRoutes = filterMenuData(item.routes);
        // 如果子菜单全部被过滤掉
        if (filteredRoutes.length === 0) {
          // 如果当前菜单项也没有 path（只是一个分组），则移除
          if (!item.path) {
            return null;
          }
          // 如果当前菜单项有 path，保留它但移除空的 routes
          return {
            ...item,
            routes: [],
          };
        }
        // 如果有子菜单被保留，更新 routes
        return {
          ...item,
          routes: filteredRoutes,
        };
      }

      return item;
    })
    .filter((item) => item !== null); // 移除标记为 null 的项
}
